
var app = angular.module('directives.paymentFields', []);

require('./directives/paymentFields.js');
require('./stylesheets/paymentFields.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentFields/index.js
 ** module id = 203
 ** module chunks = 1
 **/